import Vue from 'vue';
import App from './views/App.vue';
import router from './router';
import store from './store';
import axios from './utils/request/index';
import i18n from './utils/i18n/index';
import ElementUI from './views/element';
import filter from './filters';

import './directives.ts';
import './utils/svg-sprite.ts';
import './assets/element-reset.scss';

Vue.config.productionTip = false;
Vue.use(axios);
Vue.use(ElementUI, { size: 'mini' });
filter.init(Vue);

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app');
